import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs, { Dayjs } from 'dayjs'
import { styles } from './styles'

export interface DateRangeProps {
  onDateChange: (startDate: Date | null, endDate: Date | null) => void
}

const DateRange = (props: DateRangeProps) => {
  const { onDateChange } = props
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [isValid, setIsValid] = useState(true)

  const handleDateChange = (startDate: Date | null, endDate: Date | null) => {
    onDateChange(startDate, endDate)
  }

  useEffect(() => {
    isValid ? onDateChange(startDate, endDate) : onDateChange(null, null)
  }, [isValid, startDate, endDate, onDateChange])

  return (
    <div style={styles.container}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="From"
          onChange={(date: Dayjs | null) => {
            const newStartDate = date ? dayjs(date).toDate() : null
            handleDateChange(newStartDate, endDate)
            setStartDate(newStartDate)
          }}
          views={['day', 'month', 'year']}
          slotProps={{
            actionBar: {
              actions: ['clear']
            }
          }}
          onAccept={(date: Dayjs | null) => {
            setStartDate(date ? dayjs(date).toDate() : null)
          }}
        />
        <DatePicker
          label="To"
          disabled={!startDate}
          minDate={dayjs(startDate)}
          onChange={(date: Dayjs | null) => {
            const newEndDate = date ? dayjs(date).toDate() : null
            handleDateChange(startDate, newEndDate)
            setEndDate(newEndDate)
          }}
          onError={(error) => setIsValid(error ? false : true)}
          views={['day', 'month', 'year']}
          slotProps={{
            actionBar: {
              actions: ['clear']
            }
          }}
          onAccept={(date: Dayjs | null) => {
            setEndDate(date ? dayjs(date).toDate() : null)
          }}
        />
      </LocalizationProvider>
    </div>
  )
}

export default DateRange
